module.exports = __webpack_public_path__ + "img/prize-1.6da6a337.png";